export default [
  {
    id: 'download',
    title: 'Download',
    icon: 'mdi-download',
    action: 'download'
  }
];
